import React, { useContext, useEffect, useState } from "react";
import './locations.style.scss';
import { AccountContext } from '../../../Contexts/main.context';

const ClientLocations = () => {
    const context = useContext(AccountContext);
    const {
        activeClient, clientAccounts, updateClientAccounts,
        originalID, updateMasked, updateActiveClient,
        updateActionButtons, actionButtons, updateActiveOutlet
    } = context || {};

    const [arrayOfLocations, setArrayOfLocations] = useState([]);
    const [savedClient, updateTheClient] = useState([]);

    useEffect(() => {
        if (activeClient && clientAccounts.length > 0) {
            const matchingClients = clientAccounts.filter(client =>
                client.ID === originalID || client.locationID === originalID
            );
            setArrayOfLocations(matchingClients);
        }

        updateTheClient(activeClient);
    }, [clientAccounts, activeClient, originalID]);

    const createClient = async () => {
        updateMasked(false);
        const sendData = { ID: savedClient.ID, script: "createLocation" };
        try {
            const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(sendData),
            });

            const data = await response.json();
            if (data.status === "success") {
                const newCount = data.clientArray.filter(data => data.locationID === originalID);
                const oldRecord = data.clientArray.find(needle => needle.ID === originalID);
                const locationCount = newCount.length;
                if (oldRecord) {
                    oldRecord.LocationCount = locationCount;
                }
                updateClientAccounts(data.clientArray);
                const changedAB = actionButtons.find(bb => bb.action === 'ViewLocation');
                changedAB.label = `Locations (${locationCount + 1})`;
                updateActionButtons(actionButtons);
            } else {
                alert("Error saving client.");
            }
        } catch (error) {
            alert("An error occurred Saving Data");
        }
    };

    const cancelNew = () => {
        updateMasked(false);
    };

    const handleCreateClick = () => {
        updateMasked(true);
        if (window.confirm("Are you sure you want to create a Location with no address, etc?")) {
            createClient();
        } else {
            cancelNew();
        }
    };

    const setCurrent = (inval) => {
        const newRecord = clientAccounts.find(data => data.ID === inval);
        updateActiveClient(newRecord);

        // Highlight "ViewCitations" in sidebar and update citation count label
        const viewCitationBtn = actionButtons.find(btn => btn.action === 'ViewCitations');
        if (viewCitationBtn) {
            actionButtons.forEach(btn => btn.selected = false); // deselect all
            viewCitationBtn.selected = true;
            viewCitationBtn.label = `Citations (${newRecord.citationCount || 0})`;
            updateActionButtons([...actionButtons]);
        }

        updateActiveOutlet('ViewCitations');
    };

    return (
        <div className="container-fluid rounded-2">
            <div className="p-2 text-center fs-4 text-navy fw-bold mb-2">
                Current Location - {activeClient.companyName} - {activeClient.theLocation}
            </div>

            <div className="d-flex flex-wrap gap-1 justify-content-center">
                {arrayOfLocations.map((location, index) => (
                    <div
                        key={index}
                        className={`location-card p-1 col-11 mb-3 ${location.ID === activeClient.ID ? 'bg-navy' : 'bg-primary'}`}
                        onClick={() => setCurrent(location.ID)}
                    >
                        <div className="text-center fw-bold h4 text-white mt-2">{location.companyName}</div>
                        <div className="fs-5 text-center fw-bold text-lemon mb-1">{location.theLocation}</div>
                        <div className="fs-5 text-center text-white">{location.city} {location.postal}</div>
                        <div className="w-100 p-1">
                            <div className="text-center h1 text-white">
                                {location.citationCount} <span className="fs-8">Citations</span>
                            </div>
                        </div>
                    </div>
                ))}

                <div
                    className="location-card col-11 mb-3 alert-success create-location-box"
                    onClick={handleCreateClick}
                    style={{ border: "3px dotted green", cursor: "pointer" }}
                >
                    <div className="text-center">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                            <path d="M12 5v14M5 12h14" stroke="green" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <div className="fw-bold h5 mt-3">Create New Location</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientLocations;
